import { Data, O } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { Period, Tax, TaxBase, TaxType } from "../../../state/types"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { useTaxActions } from "../../../actions/taxActions"

export const useActions = () => {
    const { saveTax } = useTaxActions()

    const submitTax = async (
        taxData: Data,
        createMode: boolean
    ) => {
        const { companyId, id, code, legalCode, name, type, taxBase, nonTaxableMin, nonTaxableMinPeriod } = taxData

        // VAT taxes are fixed and cannot be created or edited from the UI
        if (type === TaxType.VAT) return

        Emitter.emit(Event.DB_SUBMIT)

        const tax: Tax = {
            companyId: companyId as string,
            id: id as string,
            code: define(code) as string,
            legalCode: define(legalCode) as string,
            name: define(name) as string,
            type: define(type) as TaxType,
            taxBase: define(taxBase) as TaxBase,
            nonTaxableMin: define(nonTaxableMin) as number,
            nonTaxableMinPeriod: nonTaxableMinPeriod as O<Period>,
            yield: define(taxData.yield) as number
        }
        
        await saveTax(tax)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitTax
    }
}
